export default "__VITE_ASSET__Cyog4MbC__"